import { useTheme } from "@emotion/react";
import MonetizationOnTwoTone from "@mui/icons-material/MonetizationOnTwoTone";
import { Alert, Grid } from "@mui/material";
import { IconCloudUpload, IconLockOpen } from "@tabler/icons-react";
import { useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { fetchDetailedStats } from "store/slices/dashboard";
import RevenueCard from "ui-component/cards/RevenueCard";
import { formatBytes, renderPrice } from "views/albums/album-utils";
import ChartByMonths from "views/ui-elements/ChartByMonths";
import SubscriptionLimitWidget from "./SubscriptionLimitWidget";

const Dashboard = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const {
    data: detailedStats,
    isLoading,
    hasError: hasErrorDetailedStats,
  } = useSelector((state) => state.dashboard.detailedStats);
  const {
    data: subscription,
    isLoading: isLoadingStats,
    hasError: hasStatsError,
  } = useSelector((state) => state.dashboard.photograph);
  const intl = useIntl();
  useEffect(() => {
    dispatch(fetchDetailedStats());
  }, [dispatch]);

  return (
    <Grid container spacing={2}>
      {!isLoadingStats && !hasStatsError && (
        <Grid item xs={12}>
          <SubscriptionLimitWidget subscription={subscription} />
        </Grid>
      )}
      {!isLoading && !hasErrorDetailedStats && (
        <>
          <Grid item xs={6} md={4}>
            <RevenueCard
              color={theme.palette.secondary.dark}
              primary={intl.formatMessage({ id: "dashboard.moneyEarn" })}
              iconPrimary={MonetizationOnTwoTone}
              secondary={`${renderPrice(detailedStats.moneyEarn)} €`}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <RevenueCard
              color={theme.palette.primary.main}
              iconPrimary={IconCloudUpload}
              primary={intl.formatMessage({ id: "dashboard.nbPhotos" })}
              secondary={detailedStats.nbPhotos}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <RevenueCard
              color={theme.palette.success.main}
              iconPrimary={IconLockOpen}
              primary={intl.formatMessage({ id: "dashboard.nbPublicAlbums" })}
              secondary={detailedStats.nbPublicAlbums}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <RevenueCard
              color={theme.palette.success.dark}
              primary={intl.formatMessage({ id: "dashboard.size" })}
              secondary={formatBytes(detailedStats.size)}
            />
          </Grid>
          <Grid item xs={12} md={6} xl={4}>
            <RevenueCard
              color={theme.palette.secondary.main}
              primary={intl.formatMessage({ id: "dashboard.nbAlbums" })}
              secondary={detailedStats.nbAlbums}
            />
          </Grid>
          <Grid item xs={12}>
            <ChartByMonths
              isLoading={isLoadingStats}
              dataByMonths={detailedStats.nbPhotosByMonths}
              title={intl.formatMessage({ id: "dashboard.nbPhotosByMonths" })}
            />
          </Grid>
        </>
      )}
      {hasStatsError && !isLoadingStats && (
        <Grid item xs={12}>
          <Alert variant="filled" color="error">
            <FormattedMessage id="dashboard.error.fetch" />
          </Alert>
        </Grid>
      )}
    </Grid>
  );
};

export default Dashboard;
